import { useEffect, useState } from "react";
import { ArrowDown } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteForm from "@/components/QuoteForm";
import PassportPlanner from "@/components/PassportPlanner";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES } from "@/lib/images";

export default function QuotePage() {
  const [prefill, setPrefill] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useSeo({ title: "Start Planning Your Trip | Inforno Travel", description: "Tell us about the trip you're planning and a Travel Experience Specialist will help you explore the right options — or try the Passport Planner for instant ideas." });

  const scrollToForm = (e) => {
    e.preventDefault();
    document.getElementById("inquiry-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <section className="relative h-[55vh] min-h-[420px] w-full overflow-hidden">
        <img src={IMAGES.yacht} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-noir via-noir/50 to-black/55" />
        <div className="relative z-10 h-full max-w-[1500px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-16">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-[0.45em] text-gold mb-5 [text-shadow:0_2px_10px_rgba(0,0,0,0.7)]">The Passport Experience</p>
            <h1 className="font-serif font-light tracking-tighter leading-[0.92] text-[2.4rem] sm:text-6xl lg:text-7xl text-ink max-w-4xl [text-shadow:0_2px_16px_rgba(0,0,0,0.65)]">Start Planning Your Trip</h1>
          </Reveal>
        </div>
      </section>

      {/* Path 1 — need inspiration → Passport Planner */}
      <section className="py-16 md:py-20 px-6 md:px-12 bg-noir">
        <div className="max-w-[1500px] mx-auto max-w-3xl">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-[0.4em] text-gold mb-3">Not sure where to go?</p>
            <h2 className="font-serif text-3xl md:text-4xl font-light tracking-tight">Passport Planner <span className="italic text-white/60">— your AI-powered trip finder</span></h2>
            <p className="font-body text-white/70 text-sm mt-3 font-light">Answer a few quick questions and get personalized trip ideas in about a minute.</p>
          </Reveal>
          <Reveal delay={0.08}><div className="mt-8"><PassportPlanner onSend={(data) => setPrefill(data)} /></div></Reveal>
        </div>
      </section>

      {/* Path 2 — already have a trip in mind → planning form (anchor) */}
      <section className="py-14 md:py-16 px-6 md:px-12 bg-[#0a0a0a] border-y border-white/10">
        <div className="max-w-[1500px] mx-auto max-w-3xl text-center">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-[0.4em] text-gold mb-3">Already have a trip in mind?</p>
            <h2 className="font-serif text-3xl md:text-4xl font-light tracking-tight">Start Planning Your Trip</h2>
            <p className="font-body text-white/70 text-sm mt-3 font-light max-w-xl mx-auto">Share what you already know and let an Inforno Travel specialist help with the next steps.</p>
            <a href="#inquiry-form" data-testid="start-trip-request-anchor" onClick={scrollToForm}
              className="mt-7 inline-flex items-center gap-2 border border-gold text-gold px-8 py-4 font-body text-xs uppercase tracking-[0.22em] hover:bg-gold hover:text-black transition-colors duration-300">
              Start My Trip Request <ArrowDown size={14} />
            </a>
          </Reveal>
        </div>
      </section>

      <QuoteForm prefill={prefill} />
      <Footer />
    </div>
  );
}
